class PubSub {
  makeListeners() {
    this.listeners = this.listeners || [];
  }

  trigger(type, data) {
    this.makeListeners();
    let leng = this.listeners.length;
    for (let i = 0; i < leng; i++) {
      let listener = this.listeners[i];
      if (listener == null) continue;
      if (listener.type == type) {
        listener.callback.call(listener.ctx || this, data);
      }
    }
    return this;
  }

  ons(types, callback, ctx) {
    types.forEach(type => {
      this.on(type, callback);
    });
  }

  on(type, callback, ctx) {
    this.makeListeners();
    this.listeners.push({
      type: type,
      callback: callback,
      ctx: ctx
    });
    return this;
  }

  off(type, callback) {
    this.makeListeners();
    for (let i = 0; i < this.listeners.length; i++) {
      let listener = this.listeners[i];
      if (listener == null) continue;

      if (
        listener.type == type &&
        (listener.callback == callback || callback == null)
      ) {
        this.listeners.splice(i, 1);
      }
    }
    return this;
  }

  allOff() {
    this.listeners = [];
    return this;
  }
}

const pubSub = new PubSub();

export default pubSub;
